import * as PIXI from 'pixi.js'
import {
	gsap
} from "gsap"

class block extends PIXI.Container {
	name = "block"
	index = -1
	block = 0
	bounds = {}
	interactive = true
	sprite = null
	isactive = false
	isdisplay = false
	constructor(block, bounds, index) {
		super()
		this.change = null
		this.block = block
		this.bounds = bounds
		this.index = index
		this.on('added', this.added)
		this.x = bounds.x
		this.y = bounds.y
		
		// super()
		// this.loader = loader
		// this.on('added',this.added)
	}
	added() {
		let rect = new PIXI.Graphics()
		rect.beginFill(0x000000)
		rect.drawRoundedRect(0, 0, this.bounds.width, this.bounds.width, 14)
		rect.endFill()
		rect.alpha = 0
		let sprite = PIXI.Sprite.from(require('../img/block_' + this.block + '.png'))
		sprite.width = this.bounds.width
		sprite.height = this.bounds.height
		let text = PIXI.Sprite.from(require('../img/block_text_' + this.block + '.png'))
		text.width = this.bounds.width
		text.height = this.bounds.width
		text.animateHandle = gsap.to(text, {
			delay:1,
			alpha: 0,
			duration: 1
		}).pause()
		
		let notice = PIXI.Sprite.from(require('../img/block_notice.png'))
		notice.width = this.bounds.width
		notice.height = this.bounds.height		
		notice.alpha = 0
		
		
		this.rect = rect
		this.sprite = sprite
		this.text = text
		this.notice = notice
		this.addChild(text)
		this.addChild(sprite)
		this.addChild(rect)
		this.addChild(notice)
	
	}
	pointerup() {

	}
	normal() {
		this.interactive = true
		this.sprite.alpha = 1
		this.rect.alpha = 0
		this.notice.alpha = 0
		this.isactive = false
		this.isdisplay = false
	}
	active() {
		this.interactive = false
		this.notice.alpha = 0
		this.rect.alpha = 0.3
		this.isactive = true
	}
	display() {
		this.interactive = false
		this.notice.alpha = 0
		this.sprite.alpha = 0
		this.rect.alpha = 0
		this.isdisplay = true
		this.text.animateHandle.play()
	}
	initChange(obj) {
		this.change = {
			block: obj.block,
			index: obj.index
		}
	}
	setChange() {
		this.block = this.change.block
		this.index = this.change.index
		this.sprite.texture = PIXI.Texture.from(require('../img/block_' + this.block + '.png'))
		this.text.texture = PIXI.Texture.from(require('../img/block_text_' + this.block + '.png'))
		this.change = null
	}
	noticeShow() {
		this.notice.alpha = 1
	}
	noticeHide() {
		this.notice.alpha = 0
	}		
}
export default block
